import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Product from '../components/Home/products/Product';
import Breadcrumb from '../components/ShearedComponents/Breadcrumb';
import ProductCardLoader from '../components/ui/loaders/ProductCardLoader';
import { useGetProductsByNavFilterMutation } from '../features/api/apiSlice';

const FilterByNav = () => {
    
    const { t } = useTranslation();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [getProductsByNavFilter, { data: products, isLoading, isError }] = useGetProductsByNavFilterMutation();
    const { navs } = useParams();

    useEffect(() => {
        getProductsByNavFilter({ 'nav': navs })
    }, [navs, getProductsByNavFilter]);

    let content = null;
    if (isLoading) {
        content = (
            <div className='grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  gap-4 mt-3'>
                <ProductCardLoader />
                <ProductCardLoader />
                <ProductCardLoader />
                <ProductCardLoader />
            </div>
        )
    }
    if (!isLoading && isError) {
        content = <h1>{t('utils.error')}</h1>
    }
    if (!isLoading && !isError && products?.length === 0) {
        content = <h1>{t('utils.notFound')}</h1>
    }
    if (!isLoading && !isError && products?.length > 0) {
        content = (
            <div className='grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  md:gap-7 gap-2 '>
                {products.map((data, i) => (
                    <Product key={i} product={data} />
                ))}
            </div>
        )
    }

    return (
        <div>
            <div className="container">
                <Breadcrumb page={navs ? navs : 'serch'} />
                <div className='md:py-5 py-1 pb-5'>
                    {content}
                </div>
            </div>
        </div>
    );
};

export default FilterByNav;